import { Button, Dropdown, Table } from 'flowbite-react';
import { debounce, get } from 'lodash';
import React, { useCallback, useEffect, useState } from 'react';
import { MdEdit } from 'react-icons/md';
import { useMutation } from 'react-query';
import { resetOTPCount, searchUser } from 'src/apis/user';
import { useToast } from 'src/context/ToastProvider';
import { UIUser, UserRole } from 'types';
import { useUserContext } from 'src/context/UserProvider';
import ModifyNumberModal from './ModifyNumberModal';
import { useSearchParams } from 'react-router-dom';
import { registerForDrive } from 'src/apis/offlineDrive';
import RgisterForDriveModal from './RgisterForDriveModal';
import EditDriveLabelModal from './EditDriveLabelModal';
import { BsThreeDotsVertical } from 'react-icons/bs';

const UpdateUserPhoneNumber = () => {
  const { user } = useUserContext();

  const [searchName, setSearchName] = useState('');
  const [searchEmail, setSearchEmail] = useState('');
  const [searchPhone, setSearchPhone] = useState('');
  const [searchStudentId, setSearchStudentId] = useState('');
  const [users, setUsers] = useState<UIUser[]>([]);
  const [currentUser, setCurrentUser] = useState<UIUser>();
  const [openModifyNumberModal, setOpenModifyNumberModal] = useState(false);
  const [openRegisterForDriveModal, setOpenRegisterForDriveModal] = useState(false);
  const [openEditDriveLabelModal, setOpenEditDriveLabelModal] = useState(false);
  const [remarks, setRemarks] = useState('');
  const toast = useToast();

  // Get the value of the 'driveId' parameter
  const [searchParams] = useSearchParams();
  const driveId = searchParams.get('driveId');


  const searchUserMutation = useMutation(['updateRole'], searchUser, {
    onSuccess(data) {
      setUsers(data.users);
    },
    onError(error: Error) {
      const errorMessage = get(error, ['response', 'data', 'message'], error.message);
      toast({
        title: `Error while submitting assignment: ${errorMessage}`,
        type: 'error',
      });
    },
  });

  const resetOTPCountMutation = useMutation(['resetOTPCount'], resetOTPCount, {
    onSuccess(data) {
      toast({
        title: data.message || '',
        type: 'success',
      });
    },
    onError(error: Error) {
      const errorMessage = get(error, ['response', 'data', 'message'], error.message);
      toast({
        title: `Error while submitting assignment: ${errorMessage}`,
        type: 'error',
      });
    },
  });
  const registerForDriveMutation = useMutation(['resetOTPCount'], registerForDrive, {
    onSuccess(data) {
      toast({
        title: data.message || '',
        type: 'success',
      });
    },
    onError(error: Error) {
      const errorMessage = get(error, ['response', 'data', 'message'], error.message);
      toast({
        title: `${errorMessage}`,
        type: 'error',
      });
    },
  });
  const handleresetOTPCount = (id: string) => {
    resetOTPCountMutation.mutate({ id });
  }

  const handleRegisterForDrive = ({ user, driveId, remarks, driveLabel }: { user: string; driveId: string; remarks: string; driveLabel?: string }) => {
    registerForDriveMutation.mutate({ user, driveId, remarks, driveLabel });
  };

  useEffect(() => {
    if (searchName) {
      searchUserMutation.mutate({ searchText: searchName, searchType: 'name', role: [UserRole.JOBSEEKER, UserRole.EXPERIENCED_JOBSEEKER] });
    }
  }, [searchName]);

  useEffect(() => {
    if (searchEmail) searchUserMutation.mutate({ searchText: searchEmail, searchType: 'email', role: [UserRole.JOBSEEKER, UserRole.EXPERIENCED_JOBSEEKER] });
  }, [searchEmail]);

  useEffect(() => {
    if (searchPhone) searchUserMutation.mutate({ searchText: searchPhone, searchType: 'phone', role: [UserRole.JOBSEEKER, UserRole.EXPERIENCED_JOBSEEKER] });
  }, [searchPhone]);

  useEffect(() => {
    if (searchStudentId) searchUserMutation.mutate({ searchText: searchStudentId, searchType: 'studentCode', role: [UserRole.JOBSEEKER, UserRole.EXPERIENCED_JOBSEEKER] });
  }, [searchStudentId]);

  const debouncedSearchName = useCallback(
    debounce(value => setSearchName(value), 500),
    [],
  );
  const debouncedSearchEmail = useCallback(
    debounce(value => setSearchEmail(value), 500),
    [],
  );
  const debouncedSearchPhone = useCallback(
    debounce(value => setSearchPhone(value), 500),
    [],
  );
  const debouncedSearchStudentID = useCallback(
    debounce(value => setSearchStudentId(value), 500),
    [],
  );
  return (
    <div className='w-full md:w-[80%] m-auto mt-4'>
      <h1 className='block md:hidden text-center font-[500] text-[24px]'>Update User Phone Number</h1>
      <div>
        <div className="flex flex-wrap gap-[16px] md:gap-[16px] justify-center md:justify-start mt-4">
          <div className="">
            <input
              className="relative w-[300px] rounded-lg border-gray-300 bg-white py-2.5 pl-4 pr-14 text-sm font-light tracking-wide placeholder-gray-400 transition-all duration-300 focus:border-blue-500 focus:ring focus:ring-blue-500/20 disabled:cursor-not-allowed disabled:opacity-40 dark:border-slate-600 dark:bg-slate-800 dark:text-white/80"
              type="text"
              placeholder="Search by Name"
              defaultValue={searchName}
              onChange={e => debouncedSearchName(e.target.value)}
            ></input>
          </div>
          <div className="">
            <input
              className="relative w-[300px] rounded-lg border-gray-300 bg-white py-2.5 pl-4 pr-14 text-sm font-light tracking-wide placeholder-gray-400 transition-all duration-300 focus:border-blue-500 focus:ring focus:ring-blue-500/20 disabled:cursor-not-allowed disabled:opacity-40 dark:border-slate-600 dark:bg-slate-800 dark:text-white/80"
              type="text"
              placeholder="Search by Email"
              defaultValue={searchEmail}
              onChange={e => debouncedSearchEmail(e.target.value)}
            ></input>
          </div>
          <div className="">
            <input
              className="relative w-[300px] rounded-lg border-gray-300 bg-white py-2.5 pl-4 pr-14 text-sm font-light tracking-wide placeholder-gray-400 transition-all duration-300 focus:border-blue-500 focus:ring focus:ring-blue-500/20 disabled:cursor-not-allowed disabled:opacity-40 dark:border-slate-600 dark:bg-slate-800 dark:text-white/80"
              type="text"
              placeholder="Search by Phone"
              defaultValue={searchPhone}
              onChange={e => debouncedSearchPhone(e.target.value)}
            ></input>
          </div>
          <div className="">
            <input
              className="relative w-[300px] rounded-lg border-gray-300 bg-white py-2.5 pl-4 pr-14 text-sm font-light tracking-wide placeholder-gray-400 transition-all duration-300 focus:border-blue-500 focus:ring focus:ring-blue-500/20 disabled:cursor-not-allowed disabled:opacity-40 dark:border-slate-600 dark:bg-slate-800 dark:text-white/80"
              type="text"
              placeholder="Search by Student ID"
              defaultValue={searchStudentId}
              onChange={e => debouncedSearchStudentID(e.target.value)}
            ></input>
          </div>
        </div>
        <div className="grid overflow-auto sm:hidden mt-8">
          <Table>
            <Table.Head>
              <Table.HeadCell>Name</Table.HeadCell>
              <Table.HeadCell>Email</Table.HeadCell>
              <Table.HeadCell>Number</Table.HeadCell>
              <Table.HeadCell>Student Code</Table.HeadCell>
              <Table.HeadCell>Action</Table.HeadCell>
            </Table.Head>
            <Table.Body>
              {users?.map(user => (
                <Table.Row className="bg-white border-t" key={user._id}>
                  <Table.Cell
                    className=""
                    onClick={() => {
                      //
                    }}
                  >
                    {user.name}
                  </Table.Cell>
                  <Table.Cell>{user.email}</Table.Cell>
                  <Table.Cell>{user.phone}</Table.Cell>
                  <Table.Cell>{user.studentCode || ""}</Table.Cell>

                  <Table.Cell>
                    <div
                      onClick={() => {
                        setOpenModifyNumberModal(true);
                        setCurrentUser(user);
                      }}
                      className="flex cursor-pointer items-center gap-2 border-0 text-[#7777E7]"
                    >
                      <MdEdit />
                      Edit Phone Number
                    </div>
                  </Table.Cell>
                  <Table.Cell>
                    <div
                      onClick={() => { handleresetOTPCount(user._id) }}
                      className="flex cursor-pointer items-center gap-2 border-0 text-[#7777E7]"
                    >

                      Reset OTP Count
                    </div>
                  </Table.Cell>
                  <Table.Cell>
                    <div
                      onClick={() => {
                        setCurrentUser(user);
                        setOpenRegisterForDriveModal(true);
                      }}
                      className="flex cursor-pointer items-center gap-2 border-0 text-[#7777E7]"
                    >
                      Register In Drive
                    </div>
                  </Table.Cell>
                  <Table.Cell>
                    <div
                      onClick={() => {
                        setCurrentUser(user);
                        setOpenEditDriveLabelModal(true);
                      }}
                      className="flex cursor-pointer items-center gap-2 border-0 text-[#7777E7]"
                    >
                      <MdEdit />
                      Edit Drive Label
                    </div>
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
        {/* Mobile view */}
        <div className="md:hidden flex flex-col gap-4 mt-4 w-[90%] mx-auto">
          {users?.map(user => (
            <div key={user._id} className="bg-white border border-grey-500 p-4 rounded-md">
              <div className="flex flex-row justify-between">
                <div>
                  <div className="font-medium">{user.name}</div>
                  <div className="text-sm text-gray-500">{user.email}</div>
                  <div className="text-sm text-gray-500">{user.phone}</div>
                  <div className="text-sm text-gray-500">Student ID : {user.studentCode || ""}</div>
                </div>

                <div>
                  <Dropdown
                    inline={true}
                    arrowIcon={false}
                    placement="bottom-end"
                    color={'#C7C9D9'}
                    className="dark:!bg-[#111E2C] !text-[#E4E4EB] w-[224px] rounded-[8px]"
                    label={<BsThreeDotsVertical className="w-[24px] h-[24px]" />}
                    dismissOnClick
                  >
                    <Dropdown.Item
                      onClick={() => {
                        setOpenModifyNumberModal(true);
                        setCurrentUser(user);
                      }} className={
                        'dark:!text-[#C7C9D9] dark:hover:!bg-[#2c3c50] disabled:opacity-[0.3] disabled:cursor-not-allowed'
                      }
                    >
                      Edit Phone Number
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => { handleresetOTPCount(user._id) }}
                      className={
                        'dark:!text-[#C7C9D9] dark:hover:!bg-[#2c3c50] disabled:opacity-[0.3] disabled:cursor-not-allowed'
                      }
                    >
                      Reset OTP Count
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => {
                        setCurrentUser(user);
                        setOpenRegisterForDriveModal(true);
                      }} className={
                        'dark:!text-[#C7C9D9] dark:hover:!bg-[#2c3c50] disabled:opacity-[0.3] disabled:cursor-not-allowed'
                      }
                    >
                      Register In Drive
                    </Dropdown.Item>
                    <Dropdown.Item
                      onClick={() => {
                        setCurrentUser(user);
                        setOpenEditDriveLabelModal(true);
                      }} className={
                        'dark:!text-[#C7C9D9] dark:hover:!bg-[#2c3c50] disabled:opacity-[0.3] disabled:cursor-not-allowed'
                      }
                    >
                      Edit Drive Label
                    </Dropdown.Item>
                  </Dropdown>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      {
        openModifyNumberModal &&
        <ModifyNumberModal
          user={currentUser}
          openModifyNumberModal={openModifyNumberModal}
          setOpenModifyNumberModal={setOpenModifyNumberModal}
        />
      }


      <RgisterForDriveModal
        user={currentUser}
        remarks={remarks}
        setRemarks={setRemarks}
        openRegisterForDriveModal={openRegisterForDriveModal}
        setOpenRegisterForDriveModal={setOpenRegisterForDriveModal}
        handleRegisterForDrive={handleRegisterForDrive}
      />

      <EditDriveLabelModal
        user={currentUser}
        openEditDriveLabelModal={openEditDriveLabelModal}
        setOpenEditDriveLabelModal={setOpenEditDriveLabelModal}
        onSuccess={() => {
          toast({
            title: 'Drive label updated successfully',
            type: 'success',
          });
        }}
      />

    </div >
  );
};

export default UpdateUserPhoneNumber;
